/**
 * El asistente en Inicio: conversación y caja de preguntar debajo del saludo.
 *
 * Además avisa de si se ve: mientras la mascota de Inicio está en pantalla, la
 * flotante sobra; al bajar y perderla de vista, aparece la otra en la esquina
 * con la misma conversación (ver `FloatingAssistant`).
 */
import { useLayoutEffect, useRef } from 'react'
import { useI18n } from '../../lib/i18n'
import { setAssistantOpen, setHomeMascotVisible } from '../../lib/dashboardAssistant'
import { AssistantChat } from './AssistantChat'

export function HomeAssistant({ userName, avatarUrl }: { userName: string; avatarUrl?: string | null | undefined }) {
  const { t } = useI18n()
  const rootRef = useRef<HTMLDivElement>(null)

  /* Antes de pintar: si no, al entrar a Inicio asomaba un instante la flotante. */
  useLayoutEffect(() => {
    /* La caja, que va justo bajo la mascota: mientras se ve, la flotante sobra. */
    const node = rootRef.current
    if (!node || typeof IntersectionObserver === 'undefined') return
    setHomeMascotVisible(true)
    const observer = new IntersectionObserver(([entry]) => {
      const visible = Boolean(entry?.isIntersecting)
      setHomeMascotVisible(visible)
      /* De vuelta arriba, el globo flotante se cierra: la charla sigue aquí. */
      if (visible) setAssistantOpen(false)
    }, { threshold: 0.25 })
    observer.observe(node)
    return () => {
      observer.disconnect()
      setHomeMascotVisible(false)
    }
  }, [])


  return (
    <div className="dash-home-assist" ref={rootRef}>
      <AssistantChat
        variant="inline"
        lastTurnOnly
        /* Lo anterior, en el popup de la mascota flotante: tiene su propio
           scroll y no empuja el resto de Inicio. */
        olderAction={<button type="button" className="dash-assist-older-btn" onClick={() => setAssistantOpen(true)}>{t('assistant.seeAll')}</button>}
        userName={userName}
        avatarUrl={avatarUrl}
      />
    </div>
  )
}
